import { parseAppVersionFile, type AppVersionFile } from '@/utils/parseAppVersionFile';

export async function fetchAppVersionFile(): Promise<AppVersionFile | null> {
  try {
    const response = await fetch(`/version.txt?_=${Date.now()}`, {
      cache: 'no-store',
    });

    if (!response.ok) {
      return null;
    }

    const text = await response.text();
    return parseAppVersionFile(text);
  } catch {
    return null;
  }
}
